import graphql__c326693767ff847b2b94 from "./__generated__/RemoveSupplierAmountOverrideDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import {useRelayEnvironment} from "react-relay/hooks";
import {useIntl} from "react-intl";
import Section from "../form/Section";
import FormDialog from "./FormDialog";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";
import type {RemoveSupplierAmountOverrideDialogMutation} from "./__generated__/RemoveSupplierAmountOverrideDialogMutation.graphql";

type Props = {
    override: {
        id: string
        supplier?: {
            name: string
        } | null
    }
    onClose: (changed: boolean) => void
}

const RemoveSupplierAmountOverrideDialog: React.FC<Props> = ({override, onClose}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = () => {
        commitMutationWithErrorHandling<RemoveSupplierAmountOverrideDialogMutation>(
            relayEnvironment,
            {
                mutation: graphql__c326693767ff847b2b94,
                variables: {input: {id: override.id}},
                onCompleted: (_, errors) => {
                    if (errors && errors.length > 0) {
                        console.error(errors);
                    }
                    onClose(true);
                },
                onError: (error) => {
                    console.error(error);
                    onClose(false);
                },
            },
            addError,
            {customErrorMessage: intl.formatMessage({id: 'errors.failedToRemoveSupplierAmountOverride'})}
        );
    };

    return (
        <FormDialog handleCloseDialog={() => onClose(false)}
                    handleSubmission={handleSubmission}
                    initialValues={{}}
                    headline={intl.formatMessage({id: 'dialog.RemoveSupplierAmountOverrideDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'button.delete'})}
                    dangerous={true}>
            <Section>
                <p className="text-sm text-gray-600">
                    {intl.formatMessage({id: 'dialog.RemoveSupplierAmountOverrideDialog.confirmMessage'}, {supplier: override.supplier?.name ?? override.id})}
                </p>
            </Section>
        </FormDialog>
    );
};

export default RemoveSupplierAmountOverrideDialog;
